<template>
  <b-row>
    <b-card class="mb-2 col-12">
      <b-col cols="12">
        <SearchFilter :mode="'List'" @handleSubmit="searchFilterSubmit" />
      </b-col>
    </b-card>
    <b-col cols="12">
      <commonTable ref="tableCommon" :mode="tab" />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
// import commonTable from '../../table/vue-good-table/commonTableAppreve.vue'
import commonTable from "./components/commonTable.vue";
import SearchFilter from "./components/SearchFilter.vue";
import * as viewStore from "@/store/api/approve/approve.js";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    SearchFilter,
    viewStore,
  },
  methods: {
    searchFilterSubmit(params) {
      //console.log('searchFilterSubmit', params, this.$refs)
      this.$refs.tableCommon.onSearchSubmit(params);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
